import { CDK_TABLE_TEMPLATE, CdkTable } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, HostBinding, Input } from '@angular/core';

/**
 * Wrapper for the CdkTable with Suka design styles.
 */
@Component({
  selector: 'suka-table, table[suka-table]',
  exportAs: 'sukaTable',
  template: CDK_TABLE_TEMPLATE,
  providers: [{ provide: CdkTable, useExisting: SukaTable }],
  encapsulation: ViewEncapsulation.None,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SukaTable<T> extends CdkTable<T> {
  @HostBinding('class.suka-table') baseClass = true;
  @HostBinding('class.suka-table--full-width') @Input() fullWidth = false;
  @HostBinding('class.suka-table--hover') @Input() hover = false;
  /** Overrides the sticky CSS class set by the `CdkTable`. */
  protected stickyCssClass = 'suka-table-sticky';
}
